import { render, staticRenderFns } from "./SidebarFriends.vue?vue&type=template&id=6f14fa86"
import script from "./SidebarFriends.vue?vue&type=script&lang=js"
export * from "./SidebarFriends.vue?vue&type=script&lang=js"
import style0 from "./SidebarFriends.vue?vue&type=style&index=0&id=6f14fa86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports